import React from 'react';
import { useRouter } from 'next/router';
import { NextUrqlPageContext } from 'next-urql';

import { getContentInputQuery } from 'utils/getContentInputQuery';
import { isContentOnline } from 'utils/isContentOnline';
import { SupportPage } from 'ui/pages/SupportPage';
import {
  useGroqQuery,
  groqPreviewInput,
  CONTENT_QUERY,
} from 'hooks/useGroqQuery';
import { SupportPageQuery } from 'groq/pages/SupportPage';
import { NoSearchResults } from 'ui/components/NoSearchResults';
import { isServer } from 'utils/constants';

const HelpPages = () => {
  const router = useRouter();
  const supportPage = router.query.support as string[];
  const supportUrl = `/help/${supportPage.join('/')}`;

  const [pageQuery] = useGroqQuery({
    operationName: 'SupportPage',
    query: SupportPageQuery,
    variables: { supportUrl },
  });

  const isPageOnline = isContentOnline(
    {
      onlineFrom: pageQuery.data?.content?.availableFrom,
      onlineTo: pageQuery.data?.content?.availableTo,
    },
    groqPreviewInput(router.query)
  );

  if (
    (!pageQuery.data?.content?._id &&
      !pageQuery.fetching &&
      !pageQuery.stale) ||
    !isPageOnline
  )
    return <NoSearchResults />;

  return <SupportPage supportPageQuery={pageQuery} />;
};

if (isServer) {
  HelpPages.getInitialProps = async (context: NextUrqlPageContext) => {
    const supportPage = context.query.support as string[];
    const supportUrl = `/help/${supportPage.join('/')}`;
    const SupportPage = context.urqlClient.query(
      CONTENT_QUERY('SupportPage'),
      getContentInputQuery({
        query: SupportPageQuery,
        params: {
          supportUrl,
        },
        context,
      })
    );

    const [{ data }] = await Promise.all([SupportPage]);

    const isPageOnline = isContentOnline(
      {
        onlineFrom: data?.content?.availableFrom,
        onlineTo: data?.content?.availableTo,
      },
      groqPreviewInput(context.query)
    );

    if (!data?.content?._id || !isPageOnline) {
      if (context.res) context.res.statusCode = 404;
      return {}; // Fall through to allow client-side 404 page to render
    }

    // return an object that a non-empty to prevent "returned an empty object" error in logs
    return { emptyProps: true };
  };
}

export default HelpPages;
